import { Button } from "@mui/material";
import React from "react";

const PageNotFound: React.FC = () => {
  const reloadPage = () => {
    window.location.reload();
  };

  return (
    <div className="flex flex-col h-full items-center justify-center">
      <h1 className="text-[51px] text-[#000000] leading-[66px]">404</h1>
      <p className="text-[21px] text-[#000000] mb-4">Something went wrong.</p>
      <Button  sx={{ borderRadius: "5px", height: "36px", textTransform: "capitalize", }} variant="contained" color="primary" onClick={reloadPage}>
        Try Again
      </Button>
    </div>
  );
};

export default PageNotFound;
